<template>
  <div id="popUpWin">
    <div>
      <div class="cross" v-on:click="closePopUp">
        <cross-icon/>
      </div>
      <h1>Способ оплаты</h1>
      <text-input v-model.number="userSum" :label="'Сумма к оплате'" type="number"/>
    </div>
    <div class="allButtons">
      <div class="cardButtons">
        <div v-for="(item, index) in cards" :key="index" class="btnsBlock">
          <button
            class="purpleButton"
            v-on:click="selected = item.cardId"
            v-bind:class="{whiteButton: selected === item.cardId}"

          >{{item.pan}}</button>
        </div>

        <button class="purpleButton" v-bind:class="{whiteButton: selected === 1}">Оплата произвольной<br>картой</button>
<!--        <button class="purpleButton" v-on:click="selected = 2" v-bind:class="{whiteButton: selected === 2}">Оплата по СБП</button>-->
      </div>
      <div class="buttonsRightBottom">
        <button class="purpleButton" v-bind:class="{inactive: selected === ''}" v-on:click="sendPayment">Оплатить</button>
<!--        <button class="purpleButton" v-on:click="attachNewCard">Привязать карту</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import CrossIcon from '@/assets/svg/cross';
import { mapState } from 'vuex'
import TextInput from '@/components/Form/text-input'
import { catchError, prepareSumToBackend } from '@/globalFunctions/functions'
import { payAheadWithCard } from '@/requests/kariRequests'
export default {
  name: 'pay-ahead',
  components: { TextInput, CrossIcon },
  data () {
    return {
      selected: '',
      userSum: 0
    }
  },
  methods: {
    setDefaultCard () {
      const index = this.cards.findIndex((item) => { return item.isDefault });
      this.selected = this.cards[index].cardId;
    },
    // attachNewCard () {
    //   this.$store.dispatch('attachNewCard').then((res) => {
    //     window.open(res, '_blank')
    //   }).catch((res) => {
    //     alert(res)
    //   })
    // },
    calcSumToPay () {
      const instSum = this.deal.sum * 100;
      this.userSum = prepareSumToBackend(instSum - this.deal.sumFromClient);
    },
    async sendPayment () {
      this.$store.commit('showLoader', true);
      const dataWithCard = {
        orderGuid: this.deal.guid,
        id: this.selected,
        sum: this.userSum
      }
      await payAheadWithCard(dataWithCard).then((res) => {
        catchError(res).then(() => {
          setTimeout(() => {
            this.$store.commit('popUpVarChange', 8);
            this.$store.commit('showLoader', false);
            this.$store.dispatch('getInstDetail', { guid: this.deal.guid, target: 'instArr', reloadGraphic: true });
          }, 3000)
        }).catch(() => {
          this.$store.commit('showLoader', false);
          this.$store.commit('popUpVarChange', 9);
        })
      })
    },
    closePopUp () {
      this.$store.commit('closePopUp');
    },
    setPopUp (val) {
      this.$store.commit('popUpVarChange', val);
    }
  },
  computed: {
    ...mapState({
      cards: state => state.cards.userCards,
      deal: state => state.deals.selectedInst
    })
  },
  mounted () {
    this.setDefaultCard();
    this.calcSumToPay();
  }
};
</script>

<style scoped>
#popUpWin { display: flex; flex-direction: column }
#popUpWin>div>h1 { margin-bottom: 1.07vw }
#popUpWin>div>.kariInput { margin-bottom: 4.07vw }
#popUpWin>div>p { font-size: 4vw; margin-bottom: 6.40vw }
#popUpWin>.allButtons { display: flex; flex-direction: column; justify-content: space-between }
#popUpWin>.allButtons>.buttonsRightBottom { display: flex; flex-direction: column }
#popUpWin>.allButtons>.buttonsRightBottom>button { padding: 2.93vw 0; margin-bottom: 1vw }
#popUpWin>.allButtons>.buttonsRightBottom>button.inactive { pointer-events: none; background-color: rgba(191, 191, 191, 1); border: none; color: rgba(240, 240, 240, 1) }
#popUpWin>.allButtons>.cardButtons>.btnsBlock { display: flex; flex-direction: column; margin-bottom: 1vw }
#popUpWin>.allButtons>.cardButtons>.btnsBlock>.purpleButton { padding: 2.93vw 0; margin-bottom: 1vw }
#popUpWin>.allButtons>.cardButtons>.btnsBlock>.purpleButton.whiteButton { font-size: 17px; background-color: white }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { width: calc(600px - 40px) }
  #popUpWin>div>h1 { margin-bottom: 4px }
  #popUpWin>div>.kariInput { margin-bottom: 10px }
  #popUpWin>div>p { font-size: 16px; margin-bottom: 24px }
  #popUpWin>.allButtons { flex-direction: row; justify-content: space-between }
  #popUpWin>.allButtons>.buttonsRightBottom { display: flex; flex-direction: row; justify-content: normal; align-items: flex-end; width: 50%; }
  #popUpWin>.allButtons>.buttonsRightBottom>button:first-child { margin-right: 10px }
  #popUpWin>.allButtons>.buttonsRightBottom>button { padding: 13px 0; width: 100%; margin-bottom: 0 }
  #popUpWin>.allButtons>.cardButtons>.btnsBlock { display: flex; flex-direction: column; margin-bottom: 10px }
  #popUpWin>.allButtons>.cardButtons>.btnsBlock>.purpleButton { padding: 13px 7px; margin-bottom: 10px }
  #popUpWin>.allButtons>.cardButtons>.btnsBlock>.purpleButton:last-child { margin-bottom: 0 }

}

</style>
